import React, { FC } from 'react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormJobsiteSelectionDrawerManagerContent from './Content'
import CustomFormJobsiteSelectionDrawerManagerProvider from './contexts/CustomFormJobsiteSelectionDrawerManager/Provider'

type Props = {
  question: CustomFormQuestion
  questionKey: string
  disabled?: boolean
}

const CustomFormJobsiteSelectionDrawer: FC<Props> = ({ question, questionKey, disabled }) => {
  return (
    <CustomFormJobsiteSelectionDrawerManagerProvider questionKey={questionKey}>
      <CustomFormJobsiteSelectionDrawerManagerContent question={question} disabled={disabled} />
    </CustomFormJobsiteSelectionDrawerManagerProvider>
  )
}

export default CustomFormJobsiteSelectionDrawer
